import { dateFormatOptions } from "./dateFormatterConfig";

export const isoToDate = (iso?: string | null): Date | undefined => {
  if (!iso) return undefined;
  return new Date(`${iso.slice(0, 10)}T00:00:00`);
};

export const dateToIso = (date: Date | null): string => {
  if (!date) return "";
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

const dateFormatter = new Intl.DateTimeFormat("et", dateFormatOptions);

export const formatDate = (iso: string | null | undefined): string =>
  iso ? dateFormatter.format(new Date(iso)) : "-";